import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import type { SearchResult } from '@/types';

interface SearchResultRowProps {
  result: SearchResult;
  query: string;
}

export function SearchResultRow({ result, query }: SearchResultRowProps) {
  // Simple highlight - wrap matched terms in <mark>
  const highlightSnippet = (text: string) => {
    if (!query.trim()) return text;
    const terms = query.split(/\s+/).filter(Boolean);
    let highlighted = text;
    terms.forEach(term => {
      const regex = new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      highlighted = highlighted.replace(regex, '<mark class="bg-yellow-200 dark:bg-yellow-800 rounded px-0.5">$1</mark>');
    });
    return highlighted;
  };

  const href = result.category_slug && result.section_slug
    ? `/${result.category_slug}/${result.section_slug}/${result.slug}`
    : `/articles/${result.slug}`;

  return (
    <Link
      to={href}
      className="group block p-4 rounded-lg border bg-card hover:border-primary/50 hover:shadow-sm transition-all"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-muted flex items-center justify-center mt-0.5">
          <FileText className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-foreground group-hover:text-primary transition-colors">
            {result.title}
          </h3>
          <p
            className="mt-1 text-sm text-muted-foreground line-clamp-2"
            dangerouslySetInnerHTML={{ __html: highlightSnippet(result.snippet) }}
          />
          <p className="mt-2 text-xs text-muted-foreground">
            {result.category_name} / {result.section_name}
          </p>
        </div>
      </div>
    </Link>
  );
}
